import { Component } from 'react'

import EstimationStore from '../../../libs/EstimationStore'
import EstimationActions from '../../../libs/EstimationActions'

class Description extends Component {
  componentDidMount () {
    // 設定データが非同期ロードされるため、ロード完了('change'イベント)時に再描画する
    this._storeListener = EstimationStore.addListener('change', () => {
      this.forceUpdate()
    })
  }
  componentWillUnmount () {
    if (this._storeListener) this._storeListener.remove()
  }
  getHeisei (seireki) {
    return seireki - 1988
  }
  getYM (ym) {
    return {
      y: Math.floor(ym / 100),
      m: ym % 100
    }
  }
  getSetting (settingName) {
    const estimation = EstimationActions.getCurrentEstimation()
    const estimationYearMonthId = estimation.estimationYearMonthId
    const settingList = EstimationStore.getDataFromStorage(settingName)
    // sessionStorage 未ロード時は false が返るため、配列でない場合は未定義を返す
    if (!Array.isArray(settingList)) return undefined
    return settingList.filter(setting => ((estimationYearMonthId >= setting.startMonth && estimationYearMonthId <= setting.endMonth)))[0]
  }
  getWareki (ym) {
    const year = this.getYM(ym).y
    const month = this.getYM(ym).m
    if (year > 2019 || (year === 2019 && month >= 5)) {
      const wareki = year - 2018;
      return "令和" + (wareki === 1 ? "元" : wareki) + "年" + month + "月";
    } else if (year >= 1989) {
      const wareki = year - 1988;
      return "平成" + (wareki === 1 ? "元" : wareki) + "年" + month + "月";
    } else {
      return "昭和以前";
    }
  }
}
export default Description



// WEBPACK FOOTER //
// ./src/company_user/print/LaborUnitPriceTab/abstract/Description.js